import React from 'react';
import { Route } from 'react-router';
import PrivateForms from '../../components/Pages/Forms/PrivateForms';


const routes = <Route path="forms" component={PrivateForms.LandingPage} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/forms.js